import { useIsWide } from 'src/hooks/useMediaQuery';

export type NavPlacement = 'top' | 'bottom';

/** The first segment of the addresses whose screens stand without the tab bar. */
const NO_TAB_BAR_PATHS: string[] = ['listing', 'rental', 'auth-modal', 'register'];

/** Whether the screen at `pathname` stands without the tab bar. */
export const hidesTabBar = (pathname: string): boolean => NO_TAB_BAR_PATHS.includes(pathname.split('/')[1]);

/**
 * Where the tab bar sits on the screen at `pathname`: along the bottom on a phone and a tablet,
 * across the top from the `md` breakpoint (ergonomics §3.2) — and nowhere on a screen without it.
 *
 * The document carries the answer as `html[data-nav]` (`root.tsx`), for the one rule in
 * `normalize.css` that moves the scroll container below a top bar; a screen without the bar has no
 * attribute and keeps the whole height. It is part of the markup the server sends, so a laptop's
 * first paint already has the screen where it will stay.
 */
export const navPlacement = (pathname: string, wide: boolean): NavPlacement | undefined =>
  hidesTabBar(pathname) ? undefined : wide ? 'top' : 'bottom';

/** Where the bar sits when it is shown. */
export const useNavPlacement = (): NavPlacement => (useIsWide() ? 'top' : 'bottom');
